export default __webpack_public_path__ + "static/resources-banner-bg-030d87c4760b344dd17d4afc39b920ad.jpg";